"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _color = _interopRequireDefault(require("../../../modifiers/color"));

var _utils = require("../../../utils");

var _commonUIColors = require("../../../utils/commonUIColors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var colorModifiers = (0, _utils.applyDynamicModifiers)('badgeColor', function (_ref) {
  var badgeColor = _ref.badgeColor;
  return (0, _styledComponents.css)(["", ";"], badgeColor && badgeColor in _commonUIColors.commonUIColors && (0, _color.default)(_commonUIColors.commonUIColors[badgeColor]));
});
var IconWrapper = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "IconWrapper",
  componentId: "sc-1e8ws53-0"
})(["width:", ";height:", ";padding:", ";border-radius:2px;", ";", ";"], (0, _rem.default)(_spacing.default.base * 2), (0, _rem.default)(_spacing.default.base * 2), (0, _rem.default)(_spacing.default.base * 0.4), (0, _color.default)(_commonUIColors.commonUIColors.information), colorModifiers);
var _default = IconWrapper;
exports.default = _default;